import { useTranslation } from 'react-i18next';

const SUPPORT_EMAIL = 'ampera.dalemkaum@gmail.com';

export default function DeleteAccount() {
  const { t } = useTranslation();

  const mailtoHref = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
    t('deleteAccount.email.subject')
  )}&body=${encodeURIComponent(t('deleteAccount.email.body'))}`;

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('deleteAccount.title')}</h1>
        <p className="text-sm text-gray-500 mb-10">{t('deleteAccount.lastUpdated')}</p>

        <div className="prose prose-gray max-w-none space-y-8">
          {/* Introduction */}
          <section>
            <p className="text-gray-700 leading-relaxed">{t('deleteAccount.intro')}</p>
          </section>

          {/* How to request deletion */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('deleteAccount.how.title')}</h2>
            <p className="text-gray-700 mb-3">{t('deleteAccount.how.desc')}</p>
            <ol className="list-decimal pl-6 text-gray-700 space-y-1">
              {(t('deleteAccount.how.items', { returnObjects: true }) || []).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ol>

            <a
              href={mailtoHref}
              className="inline-block mt-6 rounded-lg bg-primary-600 px-6 py-3 text-white font-semibold no-underline hover:bg-primary-700 transition-colors"
            >
              {t('deleteAccount.email.cta')}
            </a>
            <p className="text-sm text-gray-500 mt-3">
              {t('deleteAccount.email.fallback')}{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary-600 hover:underline">
                {SUPPORT_EMAIL}
              </a>
            </p>
          </section>

          {/* What gets deleted */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('deleteAccount.deleted.title')}</h2>
            <p className="text-gray-700 mb-3">{t('deleteAccount.deleted.desc')}</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-1">
              {(t('deleteAccount.deleted.items', { returnObjects: true }) || []).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* What we keep, and why */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('deleteAccount.retained.title')}</h2>
            <p className="text-gray-700 mb-3">{t('deleteAccount.retained.desc')}</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-1">
              {(t('deleteAccount.retained.items', { returnObjects: true }) || []).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <p className="text-gray-700 mt-3">{t('deleteAccount.retained.note')}</p>
          </section>

          {/* How long it takes */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('deleteAccount.timeline.title')}</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-1">
              {(t('deleteAccount.timeline.items', { returnObjects: true }) || []).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('deleteAccount.contact.title')}</h2>
            <p className="text-gray-700">{t('deleteAccount.contact.desc')}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
